import router from '@/router';
import { NewClientGetters, NewClientMutations, NewClientActions } from './new-client.keys';
import { clientsListingService } from '@/app/features/clients/features/client-details/client-details.service';
import { TolErrorsActions } from '@/app/features/tol-errors/tol-errors.keys';
import { TolMessagesActions } from '@/app/features/tol-messages/tol-messages.keys';
import { ClientDetailsActions } from '@/app/features/clients/features/client-details/client-details.keys';
import format from 'date-fns/format';
export const getInitialState = () => {
  return {
    client: {
      created_at: format(new Date(), 'YYYY-MM-DD'),
      reference_number: null,
      created_by_id: null,
      created_comment: null,
      active: true,
      name: null,
      type: 'REGULAR',
      credit_check: format(new Date(), 'YYYY-MM-DD'),
      requires_purchase_order: false,
      address_id: null,
      phone: null,
      phone_type: null,
      payment_terms: null,
      additional_comment: null
    },
    addressList: [],
    billingMethods: [],
    contacts: []
  };
};
export const newClientStore = {
  state: getInitialState,
  getters: {
    [NewClientGetters.GetNewClient]: state => state.client,
    [NewClientGetters.GetNewClientAddressList]: state => state.addressList
  },
  mutations: {
    [NewClientMutations.UpdateNewClientDetails](state, clientDetails) {
      state.client = clientDetails;
    },
    [NewClientMutations.ResetNewClientDetails](state) {
      state.client = {
        created_at: format(new Date(), 'YYYY-MM-DD'),
        reference_number: null,
        created_by_id: null,
        created_comment: null,
        active: true,
        name: null,
        type: 'REGULAR',
        credit_check: format(new Date(), 'YYYY-MM-DD'),
        requires_purchase_order: false,
        address_id: null,
        phone: null,
        phone_type: null,
        payment_terms: null,
        additional_comment: null
      };
      state.addressList = [];
      state.billingMethods = [];
      state.contacts = [];
    },
    [NewClientMutations.AddNewClientAddress](state, address) {
      state.addressList.push(address);
    },
    [NewClientMutations.UpdateNewClientAddress](state, address) {
      state.addressList.forEach((element, index) => {
        if (element.id === address.updateAddress.id) {
          let updatedAddress = address.updateAddress;
          updatedAddress[address.name] = address.value;
          state.addressList[index] = updatedAddress;
        }
      });
    },
    [NewClientMutations.UpdateNewClientDefaultAddress](state, addressId) {
      state.client.address_id = addressId;
    }
  },
  actions: {
    [NewClientActions.UpdateNewClientDetails]({ commit }, clientDetails) {
      commit(NewClientMutations.UpdateNewClientDetails, clientDetails);
    },
    [NewClientActions.ResetNewClientDetails]({ commit }) {
      commit(NewClientMutations.ResetNewClientDetails);
    },
    [NewClientActions.AddNewClientAddress]({ commit }, address) {
      commit(NewClientMutations.AddNewClientAddress, address);
    },
    [NewClientActions.UpdateNewClientAddress]({ commit }, address) {
      commit(NewClientMutations.UpdateNewClientAddress, address);
    },
    [NewClientActions.UpdateNewClientDefaultAddress]({ commit }, id) {
      commit(NewClientMutations.UpdateNewClientDefaultAddress, id);
    },
    [NewClientActions.SaveNewClientDetails]({ state, dispatch }, section) {
      clientsListingService
        .saveClientDetails(
          {
            client: state.client,
            address: state.addressList,
            billingMethods: state.billingMethods,
            contacts: state.contacts
          },
          section
        )
        .then(status => {
          dispatch(TolErrorsActions.ClearAll);
          if (status && status.message === 'success') {
            dispatch(ClientDetailsActions.RetrieveClientDetails, status.data).then(
              router
                .replace({ name: 'client-details', params: { id: status.data } })
                .catch(error => {
                  if (error.name !== 'NavigationDuplicated') {
                    dispatch(TolErrorsActions.SetError, { error });
                  }
                })
            );

            if (status.info) {
              dispatch(TolMessagesActions.SetMessages, status.info);
            }
          } else {
            dispatch(TolMessagesActions.ClearAll);
            const messages = Object.values(status.errors);
            let items = [];
            for (let item of messages) {
              items = items.concat(item);
            }
            dispatch(TolErrorsActions.SetError, { items });
          }
        });
    }
  }
};
